import React from 'react';
import { localization } from './localization';
import { useContentLocalizer } from '../../../hooks/useContentLocalizer';
import { Illustration, Subtitle } from './styles';
import { BdsGrid, BdsTypo } from 'blip-ds/dist/blip-ds-react';

interface EmptySearchStateProps {
  subtitle?: string;
}

const EmptySearchState: React.FC<EmptySearchStateProps> = ({ subtitle }) => {
  const translate = useContentLocalizer(localization);
  const displaySubtitle = subtitle ?? translate.subtitle;

  return (
    <BdsGrid direction="column" align-items="center" gap="3" padding="3" justify-content="center">
      <Illustration type="default" name="search-1" />
      <BdsGrid direction="column" gap="1" align-items="center" justify-content="center">
        <BdsTypo variant="fs-20" bold="bold" margin={false}>
          {translate.title}
        </BdsTypo>
        {displaySubtitle && (
          <Subtitle>
            <BdsTypo variant="fs-14">{displaySubtitle}</BdsTypo>
          </Subtitle>
        )}
      </BdsGrid>
    </BdsGrid>
  );
};

export default EmptySearchState;
